<template lang="pug">
  div
    b-row.mb-4.align-items-center
      b-col(md="6")
        b-input-group
          b-form-input(:placeholder="`Buscar ${accountName}...`", type="search", v-model="search_text")
          b-input-group-append
            b-button(variant="soft-secondary")
              .d-flex.align-items-center
                b-spinner(small, v-if="loading", variant="primary")
                search-icon.icon-sm(v-else)
                span.ml-2(v-if="$breakpoint.mdUp") Buscar
    div(v-if="accounts.length")
      b-card.card-inactive.bg-light.mb-2
        b-row.align-items-center.justify-content-center(no-gutters)
          b-col
            slick(ref='accounts-gallery', :options='slick_options', @beforeChange="beforeAccountsChange", @afterChange="accountsChanged")
              b-card.mb-0(v-for="account in accounts", :key="account.account_id")
                b-row.align-items-center
                  b-col
                    small.text-help.uppercase {{accountName}}
                    h4 {{ account.name }}
                    p.text-help.mb-0 Última actualización {{ $moment(account.updatedAt).fromNow() }}
      p.text-sm Mostrando {{ accounts.length }} de {{ total_count }}.
        span.text-secondary.ml-2 Prueba con el buscador para encontrar {{accountName}}s más rápido.
    empty-message(v-else, :message="`No hay ${accountName}}s`")
    Plans.mt-5(:plans="plans", @geturl="getURL", :account_name="currentAccount.name")
    b-modal(v-model="payment_modal", :hide-footer="true", @hide="setPaymentUrl('about:blank')")
      template(slot="modal-title")
        .d-flex.align-items-center
          lock-icon.icon-md.mr-2.mb-1(:class="secure_connection ? 'text-success' : 'text-secondary'")
          span Conexión segura
      .d-flex.justify-content-center(style="margin:-1rem;")
        iframe(frameborder="0", width="100%", style="max-width:498px;height:645px;", id="payment_iframe")
</template>

<script>
import Slick from 'vue-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Plans from '../../components/Plans.vue'

import { createNamespacedHelpers, mapActions } from 'vuex'
import _debounce from "lodash.debounce";
const organizationController = createNamespacedHelpers('organization')
const planController = createNamespacedHelpers('plan')

export default {
  data () {
    return {
      subscriptions: [],
      organization: {},
      payment_modal: false,
      slick_options: {
        infinite: false,
        speed: 300,
        slidesToShow: 1.2,
        arrows: true,
        centerMode: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              infinite: false,
              speed: 300,
              slidesToShow: 1,
              arrows: true,
              centerMode: true,
            }
          }
        ]
      },
      search_text: '',
      loading: false,
      account_index: 0,
      total_count: 0,
      secure_connection: false
    }
  },
  computed: {
    ...organizationController.mapState({
      accounts: state => state.accounts
    }),
    ...planController.mapState({
      plans: state => state.plans
    }),
    currentAccount () {
      if (!this.accounts.length) return {}

      try {
        return this.accounts[this.account_index]
      } catch (e) {
        return {}
      }
    },
    isPartnerView () {
      return (new RegExp('^partner-')).test(this.$route.name)
    },
    organizationId () {
      return this.isPartnerView ? this.organization_id : this.$route.params.organization_id
    },
    accountName () {
      return this.isPartnerView ? 'chatbot' : 'cuenta'
    }
  },
  methods: {
    ...mapActions(['service/subscriptions', 'organization/accounts', 'plan/all', 'plan_payment/generateURL', 'account/billings', 'partner/organizations']),
    getOrganizationId () {
      let self = this
      this['partner/organizations']({
        partner_id: self.$route.params.partner_id,
        callback: async res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.organization_id = res.resource[0].organization_id
            self.getAccounts()
            //self.getAccounts(res.resource[0].organization_id)
          }
        }
      })
    },
    getOrganizationData () {
      let self = this

      this['organization/get']({
        organization_id: self.organizationId,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.organization = res.resource
            this.getPlans()
          }
        }
      })
    },
    getBilling () {
      let self = this
      // this.showLoadingScreen()

      this['account/billings']({
        account_id: this.accounts[this.account_index].account_id,
        params: {
          status: 'Active'
        },
        callback: res => {
          console.log(res);
          self.hideLoadingScreen()
          if (res.error) {
            self.$message.error(res.error)
          } else {
            if (res.resource && res.resource.Subscriptions) {
              for (let subscription of res.resource.Subscriptions) {
                let expire_date = self.$moment(subscription.expire_date),
                    diff_days = self.$moment().diff(expire_date, 'days'),
                    diff_months = self.$moment().diff(expire_date, 'months'),
                    diff_years = self.$moment().diff(expire_date, 'years')

                subscription.should_renew = true

                if (diff_days == 0) { // is today
                  subscription.expire_date_string = 'Hoy vence tu plan'
                } else if (diff_days < 0) { // is in the future
                  if ((diff_days * -1) > 10)
                    subscription.should_renew = false

                  if ((diff_days * -1) > 730) { // min 2 years
                    subscription.expire_date_string = `Vence en ${diff_years * -1} años`
                  } else if ((diff_days * -1) > 62) { // min 2 months
                    subscription.expire_date_string = `Vence en ${diff_months * -1} meses`
                  } else { // days left
                    subscription.expire_date_string = `Vence en ${diff_days * -1} días`
                  }
                } else { // is in the past
                  subscription.expire_date_string = `Terminó hace ${diff_days} días`
                }
              }
            } else {
              self.$message.info('Esta cuenta aún no está suscrita a un plan')
            }
          }
        }
      })
    },
    getPlans () {
      let self = this

      this['service/subscriptions']({
        service_id: self.organization.service_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.subscriptions = res.resource
          }
        }
      })
    },
    beforeAccountsChange (event, slick, currentSlide, nextSlide) {
      this.showLoadingScreen()
    },
    accountsChanged (event, slick, currentSlide) {
      this.account_index = currentSlide
      this.$nextTick(() => {
        this.hideLoadingScreen()
        this.getBilling()
      })
    },
    getURL (plan_id) {
      let self = this

      this.showLoadingScreen()

      let account = this.accounts[this.account_index]
      this['plan_payment/generateURL']({
        plan_id: plan_id,
        account_id: account.account_id,
        billed_months: 1,
        callback: res => {
          self.hideLoadingScreen()
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.payment_modal = true
            console.log(res)
            self.$nextTick(() => {
              self.setPaymentUrl(res.resource.cadena_pago)
            })
          }
        }
      })
    },
    setPaymentUrl (url) {
      document.getElementById('payment_iframe').src = url
    }
  },
  mounted () {
    this.setPaginationLimit(5)
    //this.getBilling()
    //this.getOrganizationData()
    this['plan/all']({
      callback: res => {
        if (res.error) {
          self.$message.error(res.error)
        }
      }
    })

    this.getAccounts = _debounce(() => {
      let self = this
      this.loading = true

      let paginationParams = this.search_text ? {} : this.paginationParamsObject

      let params = {
        ...paginationParams
      }
      if (self.search_text) params.name = self.search_text

      this['organization/accounts']({
        organization_id: self.organizationId,
        admin_id: self.getCurrentUser().admin_id,
        params,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.total_count = res.total
            self.account_index = 0
            self.$nextTick(() => {
              self.getBilling()
            })
          }
        }
      })
    }, 300, {leading: false, trailing: true})

    if (this.isPartnerView) {
      this.getOrganizationId()
    } else {
      this.getAccounts()
    }

    window.addEventListener('message', message => {
      if (message.data == 'paymentmodal:close') {
        this.payment_modal = false
        window.location.reload()
      }
    })
  },
  components: { Slick, Plans },
  watch: {
    search_text () {
      this.resetPaginationData()
      this.getAccounts()
    },
    payment_modal (value) {
      if (value) {
        setTimeout(() => {
          this.secure_connection = true
        }, 1300);
      } else {
        this.secure_connection = false
      }
    }
  },
}
</script>

<style lang="scss">
  .slick-slide {
    margin-right: 10px;
    opacity: .5;

    &.slick-current {
      opacity: 1;
    }
  }

  .slick-next {
    right: 1rem;
    z-index: 10 !important;
  }

  .slick-prev {
    left: .3rem;
    z-index: 10 !important;
  }

  .slick-prev:before, .slick-next:before {
    font-size: 30px;
    color: #6e84a3;
    opacity: 1;
    z-index: 10 !important;
  }
</style>
